import React from "react"
import { Stack, Flex, Text } from "frontend/components/MantineStandard"
import { Container, SocialButton } from "./GotvCampaignFooter.styles"
import { XTwitterFarFAIcon } from "QuorumGrassroots/widgets/ReusableComponents/Icons"

export interface SocialPlatform {
    platform: number
    icon: string
    onClick: () => void
    dataCy: string
}

export interface GotvCampaignFooterProps {
    socialPlatforms?: SocialPlatform[]
    socialHeading?: string
}

export const DEFAULT_SOCIAL_HEADER = "Share on social media to get more people to GOTV"

export const GotvCampaignFooter: React.FC<GotvCampaignFooterProps> = ({
    socialPlatforms = [],
    socialHeading = DEFAULT_SOCIAL_HEADER,
}) => {
    const getSocialIcon = (platform: number, icon: string) => {
        // Handle X/Twitter special case
        if (platform === DjangIO.app.grassroots.enums.SocialMediaType.twitter.value) {
            return <XTwitterFarFAIcon size={16} color="white" />
        }
        return <i className={`fa ${icon}`} aria-hidden="true" />
    }

    const getSocialAriaLabel = (platform: number) => {
        const platformEnum = DjangIO.app.grassroots.enums.SocialMediaType.by_value(platform)
        // Use "X" instead of "Twitter" for the new branding
        const platformName =
            platform === DjangIO.app.grassroots.enums.SocialMediaType.twitter.value
                ? "X"
                : platformEnum?.label || "Unknown platform"
        return `Share on ${platformName}`
    }

    const getSocialButtonStyle = (platform: number) => {
        // Return black background for X/Twitter
        if (platform === DjangIO.app.grassroots.enums.SocialMediaType.twitter.value) {
            return { backgroundColor: "#000000" }
        }
        return {}
    }

    return (
        <Container data-cy="gotv-campaign-footer">
            {socialPlatforms.length > 0 && (
                <Stack spacing="md" data-cy="gotv-social-section">
                    <Text color="dimmed" align="center">
                        {socialHeading}
                    </Text>
                    <Flex gap="sm" justify="center" align="center" wrap="wrap">
                        {socialPlatforms.map((social) => (
                            <SocialButton
                                key={social.platform}
                                onClick={social.onClick}
                                data-cy={social.dataCy}
                                aria-label={getSocialAriaLabel(social.platform)}
                                style={getSocialButtonStyle(social.platform)}
                            >
                                {getSocialIcon(social.platform, social.icon)}
                            </SocialButton>
                        ))}
                    </Flex>
                </Stack>
            )}
        </Container>
    )
}
